import { Heading, HeadingProps, Text } from "@chakra-ui/react";
import { EditablePreviewProps } from "@chakra-ui/react";

import { HEADING_STYLES } from "../theme/styles/heading-styles";

import { RanaEditable } from "./rana-editable";

type HeadingType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

interface RanaHeadingProps extends HeadingProps {
  type: HeadingType;
  addDot?: boolean;
}
export function RanaHeading({ children, type, addDot, ...rest }: RanaHeadingProps) {
  return (
    <Heading {...rest} as={type} size={type} alignContent="left">
      {children}
      {addDot && (
        <Text
          as="span"
          color="brand.clear_creek"
          fontFamily="Roboto Light"
          fontWeight="700"
          style={{ fontFeatureSettings: "'clig' off, 'liga' off" }}
        >
          .
        </Text>
      )}
    </Heading>
  );
}

interface RanaHeadingEditablePreviewProps extends EditablePreviewProps {
  type: HeadingType;
}

export function RanaHeadingEditablePreview({ type, ...rest }: RanaHeadingEditablePreviewProps) {
  const styles = HEADING_STYLES.sizes[type];

  return <RanaEditable.Preview as={type} {...HEADING_STYLES.baseStyle} {...styles} {...rest} />;
}
